
export class GasCabinetPara {
    constructor({
        id= ``,
        prdDate= ``,
        recTime= ``,
        locName= ``,
        locId= ``,
        pipeTemp= ``,
        dustRemovalTemp= ``,
        intakeTemp1= ``,
        intakePressure1= ``,
        selfTemp1= ``,
        pressureDiff1= ``,
        intakeTemp2= ``,
        intakePressure2= ``,
        selfTemp2= ``,
        pressureDiff2= ``,
        intakeTemp3= ``,
        intakePressure3= ``,
        selfTemp3= ``,
        pressureDiff3= ``,
        fanSpeed= ``,
        fanPower= ``,
        frontVibration= ``,
        backVibration= ``,
        maxWindingTemp= ``,
        maxMotorTemp= ``,
        fanTemp= ``,
        outletPressure= ``,
    }={}){
        this.id = id;
        this.prdDate = prdDate;
        this.recTime = recTime;
        this.locName = locName;
        this.locId = locId;
        this.pipeTemp = pipeTemp;
        this.dustRemovalTemp = dustRemovalTemp;
        this.intakeTemp1 = intakeTemp1;
        this.intakePressure1 = intakePressure1;
        this.selfTemp1 = selfTemp1;
        this.pressureDiff1 = pressureDiff1;
        this.intakeTemp2 = intakeTemp2;
        this.intakePressure2 = intakePressure2;
        this.selfTemp2 = selfTemp2;
        this.pressureDiff2 = pressureDiff2;
        this.intakeTemp3 = intakeTemp3;
        this.intakePressure3 = intakePressure3;
        this.selfTemp3 = selfTemp3;
        this.pressureDiff3 = pressureDiff3;
        this.fanSpeed = fanSpeed;
        this.fanPower = fanPower;
        this.frontVibration = frontVibration;
        this.backVibration = backVibration;
        this.maxWindingTemp = maxWindingTemp;
        this.maxMotorTemp = maxMotorTemp;
        this.fanTemp = fanTemp;
        this.outletPressure = outletPressure;
    }
}

export function gridFields() {
    return Object.freeze([
        {
            key: 'prdDate',
            label: 'lbl.basic.date',
            sortable: true,
            form: {
              type: 'datepicker'
            }
        },
        {
          key: 'recTime',
          label: 'lbl.basic.datetime',
          sortable: true,
          form: {
            type: 'timepicker'
          }
        },
        {
          key: 'locName',
          label: 'lbl.fm.locationName',
          filterable: true,
          default: 'default',
          form: {
            type: 'dimSearch',
            url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
            config: {
              validate: "", // 参数检查，可以是正则表达式等
              bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
              bindProp: "locName", // 显示的属性的名称
              submitProp: "locName" // 提交的属性
            }
          }
        },
        {
          key: 'locId',
          label: 'lbl.formulaPlan.locationCode',
          notInTable: true,
          form: {
            type: 'dimSearch',
            url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
            config: {
              validate: "", // 参数检查，可以是正则表达式等
              bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
              bindProp: "id", // 显示的属性的名称
              submitProp: "id" // 提交的属性
            }
          }
        },
        {
            key: 'pipeTemp',
            label: 'lbl.gcm.pipeTemp',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'dustRemovalTemp',
            label: 'lbl.gcm.dustRemovalTemp',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'intakeTemp1',
            label: 'lbl.gcm.intakeTemp1',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'intakePressure1',
            label: 'lbl.gcm.intakePressure1',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'selfTemp1',
            label: 'lbl.gcm.selfTemp1',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'pressureDiff1',
            label: 'lbl.gcm.pressureDiff1',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'intakeTemp2',
            label: 'lbl.gcm.intakeTemp2',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'intakePressure2',
            label: 'lbl.gcm.intakePressure2',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'selfTemp2',
            label: 'lbl.gcm.selfTemp2',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'pressureDiff2',
            label: 'lbl.gcm.pressureDiff2',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'intakeTemp3',
            label: 'lbl.gcm.intakeTemp3',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'intakePressure3',
            label: 'lbl.gcm.intakePressure3',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'selfTemp3',
            label: 'lbl.gcm.selfTemp3',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'pressureDiff3',
            label: 'lbl.gcm.pressureDiff3',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'fanSpeed',
            label: 'lbl.gcm.fanSpeed',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'fanPower',
            label: 'lbl.gcm.fanPower',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'frontVibration',
            label: 'lbl.gcm.frontVibration',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'backVibration',
            label: 'lbl.gcm.backVibration',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'maxWindingTemp',
            label: 'lbl.gcm.maxWindingTemp',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'maxMotorTemp',
            label: 'lbl.gcm.maxMotorTemp',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'fanTemp',
            label: 'lbl.gcm.maxFanTemp',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'outletPressure',
            label: 'lbl.gcm.outletPressure',
            sortable: true,
            form: {
              type: 'input'
            }
        }
    ]);
}

export const fields = Object.freeze(Object.keys(new GasCabinetPara()).map(i => 'entity.'+i));

export const filterFields = [
    'filter.startTimeFilter',
    'filter.endTimeFilter',
    'filter.locNameFilter',
];

export const filter = {
    'startTimeFilter': "",
    'endTimeFilter': "",
    'locNameFilter': "default",
};